import api from './'

export default {

    /**
     * Get tags
     * @param params
     */
    get(params) {
        return api
            .get(`/tags`, {
                params: params
            })
            .then(response => {
                return response.data
            });
    },

    /**
     * Create tag
     * @param data
     */
    create(data) {
        return api
            .post(`/tags`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Show tag
     * @param tagId
     */
    show(tagId, params) {
        return api
            .get(`/tags/${tagId}`, {
                params: params
            })
            .then(response => {
                return response.data
            })
    },

    /**
     * Update tag
     * @param tagId
     * @param data
     */
    update(tagId, data) {
        return api
            .put(`/tags/${tagId}`, data)
            .then(response => {
                return response.data
            })
    },

    /**
     * Delete tag
     * @param tagId
     */
    delete(tagId) {
        return api
            .delete(`/tags/${tagId}`)
            .then(response => {
                return response.data
            })
    }

}
